module.exports = __webpack_public_path__ + "static/pill-3e92a60c61636483f63ad0fc0ee0bd9b.gif";